/**
 * 악덕알리미 서버(도메인) 전환 BS — 장비불러 dev bridge 이식(경량판, 전용 페이지 없이 BS).
 *
 * 사용: $j.F.Devil.DevBridge.open()  (Sites/Devil/Bootstrap 의 상단 타이틀 7연속 탭으로 진입)
 *
 * 도메인 목록에서 선택 → 확인 → $j.F.App.changeHost(host, tag) 발화(공용 브릿지).
 * 앱이 수락하면 새 서버로 재진입(프로세스 재시작)하므로 결과 패널 없음 — 실패 시에만 토스트.
 */

import HOSTS from '../AppHosts';

function esc(s){ return String(s==null?'':s).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c])); }

function buildTarget(){
    return {
        init(){
            const $cont = $('#' + this.id);
            this.parent.setTitle('서버(도메인) 전환');
            const origin = location.origin;
            const rows = HOSTS.map((h, i) => {
                const now = (h.host === origin);
                return `<button type="button" class="dv-host" data-idx="${i}" style="`
                    + `width:100%;text-align:left;display:flex;align-items:center;gap:10px;`
                    + `padding:14px 16px;margin-bottom:8px;border-radius:14px;cursor:pointer;`
                    + (now ? 'border:1.5px solid var(--R);background:var(--Rl);' : 'border:1px solid var(--bdr);background:var(--sf);')
                    + `">`
                    + `<span style="font-size:13px;font-weight:700;min-width:56px;color:${now ? 'var(--R)' : 'var(--t2)'}">${esc(h.tag)}</span>`
                    + `<span style="font-size:14px;color:var(--t1);flex:1;word-break:break-all">${esc(h.host)}</span>`
                    + (now ? `<span style="font-size:12px;font-weight:700;color:var(--R);flex-shrink:0">현재</span>` : '')
                    + `</button>`;
            }).join('');
            $cont.html(`<div style="padding:12px 14px 30px">`
                + `<p style="font-size:12px;color:var(--t3);margin-bottom:12px">현재 접속: <b style="color:var(--t2)">${esc(origin)}</b></p>`
                + rows
                + `</div>`);
            $cont.off('click.dvhost').on('click.dvhost', '.dv-host', function(){
                const h = HOSTS[Number($(this).data('idx'))];
                if (!h) return;
                if (h.host === origin && !confirm(`이미 ${h.tag} 도메인입니다. 그대로 적용할까요?`)) return;
                if (!confirm(`앱 접속 도메인을 아래로 변경합니다.\n\n${h.host}  (${h.tag})`)) return;

                // 수락되면 앱이 곧 새 서버로 재진입하므로 이 BS 는 사라진다 → 실패 시에만 안내.
                const A = ($j.F && $j.F.App) ? $j.F.App : null;
                const ok = (A && typeof A.changeHost === 'function') ? A.changeHost(h.host, h.tag) : false;
                if (!ok && A && typeof A.isApp === 'function' && A.isApp()) {
                    (window.BD && typeof window.BD.toast === 'function')
                        ? window.BD.toast('앱이 서버 변경을 처리하지 않았습니다 (구앱/미구현)')
                        : alert('앱이 서버 변경을 처리하지 않았습니다.');
                }
                // 앱 외 환경(브라우저)이면 runAppBroker 가 자체 alert 를 띄운다.
            });
        },
        destroy(){}
    };
}

export default class DevBridge {
    open = () => {
        $j.Ui.BS.open({ target: buildTarget(), fixedHeight: true, backClose: true });
    }
}
